<div [style.width]="width" [ngClass]="{ 'w-100 h-100': inheritSize() }">
    <img id="{{ id() }}MediaThumbnail"
        [alt]="alt()"
        class="w-100 object-fit-contain"
        [class.h-100]="inheritSize()"
        onerror="this.src='/assets/images/defaults/default-media-picture.png'"
        [src]="mediaThumbnailUri() ?? '/assets/images/defaults/default-media-picture.png'" />
</div>
